import creator from './elementCreator';

import WKT from 'ol/format/WKT.js';
import Image from 'ol/layer/Image.js';
import ImageWMS from 'ol/source/ImageWMS.js';

"use strict";
var globalFns;
globalFns = {
	forAllLayers: function (parent, fn) {
		parent.getLayers().forEach(function (child) {
			fn(child);
			if (child.getLayers) {
				globalFns.forAllLayers(child, fn);
			}
		});
	},
	getDistanceBetweenFeatureAndPoint: function (f, coords) {
		var fCoord = f.getGeometry().getClosestPoint(coords);
		return Math.sqrt(Math.pow(fCoord[0] - coords[0], 2) + Math.pow(fCoord[1] - coords[1], 2));
	},
	toggleImage: function(parent, img1, img2){
		
	},
	formatDate: function(date){
		let day = date.getDate();
		if (day < 10) {
			day = '0' + day;
		}
		let month = date.getMonth() + 1;
		if (month < 10) {
			month = `0${month}`;
		}
		let year = date.getFullYear();
		return `${year}${month}${day}`;
	},
};

export default {
	isTouchDevice: false,
	hoverClassRemoved: false,
	appConfig: null,
	map: null,
	mapMode: undefined,
	origin: [596941, 6642882],
	//mapresolutions: [66.14580, 39.68748, 21.16666, 10.58333, 5.291664, 2.645832, 1.32292, 0.66146, 0.2645832, 0.13229161],
	mapresolutionsExt: [66.14580, 39.68748, 21.16666, 10.58333, 5.291664, 2.645832, 1.32292, 0.66146, 0.2645832, 0.13229161, 0.0661458, 0.0330729],
	selectStyleCache: {},
	popoverObject: {},
	checkedContextLayers: 0,
	mapClickCtrlActive: true,
	clickInfoInProgress: false,
	selectedTeigFeature: null,
	kommuneGrenseRedered: false,
	tipWinShown: false,
	listSearch: false,
	multiEiendom: false,
	list: null,
	regbestIntranett: undefined,
	/** Saksinnsyn url-er */
	saksinnsynUrl: undefined,
	saksinnsynCasedetUrl: undefined,
	saksinnsynDocdetUrl: undefined,
	sidinmeningUrl: undefined,
	/** Kart-url'er */
	cacheurl: "",
	searchUrl: undefined,
	sakWFSUrl: undefined,
	planinnsynUrl: undefined,
	kartinnsynurl: undefined,
	geoJsonWFS: undefined,
	/** Php/ws-urler */
	phpAutocomplete: undefined,
	autocompleteUrl: undefined,
	planmetaWSUrl: undefined,
	vedtakWSUrl: undefined,
	numberOfComments: 0,
	formatDate: globalFns.formatDate,
	modes: {},
	defaults: [],
	clearLayers: ["markers", "fontmarkers", "planobj", "geoloclayer", "searchhighlight"],
	removeLayers: ["highlight"],
	registeredPlugins: {},
	GIFunctions: {},
	/** Globale funksjoner */
	waitAndThen: function (ms, fn, arg1, arg2) {
		setTimeout(function () {
			fn(arg1, arg2);
		}, ms);
	},
	lastRadioClicked: undefined,
	replaceAll: function (find, replace, str) {
		return str.replace(new RegExp(find, "g"), replace);
	},
	forAllLayers: globalFns.forAllLayers,
	clearMap: function (e) {
		var thisMap = this.map;
		this.clearLayers.forEach(function(maplayer){
			if(thisMap.getLayerById(maplayer) && e !== "keepHighlight"){
				if(maplayer === "highlight"){
					
				}else{						
					thisMap.getLayerById(maplayer).getSource().clear();
				}
			}
			if(typeof(maplayer) === "function"  && e !== "keepHighlight"){
				maplayer();
			}
		});
		this.removeLayers.forEach(function(maplayer){
			if(thisMap.getLayerById(maplayer) && e !== "keepHighlight"){
				thisMap.removeLayer(thisMap.getLayerById(maplayer));
			}
			if(typeof(maplayer) === "function"){
				maplayer();
			}
		});
		if (e !== undefined && e.currentTarget) {
			$(e.currentTarget).blur();
		}
		this.listSearch = false;
		this.list = null;
		this.map.getOverlays().getArray()[0].setPosition(undefined);
	},
	addFeaturesToOverlay: function (features, layerId) {
		var layer = this.map.getLayerById(layerId);
		features.forEach(function (f) {
			layer.getSource().addFeature(f);
		});
	},
	highlightPlan: function (plan, row, fromContext, labelElement) {
		var layer, loader, url, layerName;
		if(row){
			url = row.url + plan[row.urlKey]; 
			layerName = row.layer;
		}else {
			url= this.kartinnsynurl + "&planid=" + plan;
			layerName = "highlight_planid";
		}
		layer = new Image({
			layerId: "highlight",
			source: new ImageWMS({
				url: url,
				params: {"LAYERS": layerName},
				serverType: "mapserver"
			}),
			visible: true
		});
		$("body").css("cursor", "wait");
		if (fromContext) {
			loader = creator.createIcon({css: "fa fa-spinner fa-pulse"});
			$(labelElement).append(loader);
		}
		layer.getSource().on("imageloadend", function () {
			$("body").css("cursor", "");
			if (fromContext) {
				$(labelElement).find("i").remove();
			}
		});
		this.map.addLayer(layer);
	},
	toggleTopo4: function (visible) {
		var map = this.map;
		if (map.getLayerById("topo4")) {
			// Kommuneflate er for å maskere topo4 innenfor Oslo
			map.getLayerById("kommuneflate").setVisible(visible);
			map.getLayerById("topo4").setVisible(visible);
		}
	},
	isEmpty: function (obj) {
		var empty = true;
		if (obj === null || obj === undefined || obj.length === 0) {
			empty = true;
		} else if (obj.length > 0 || (typeof obj === "boolean" && obj === true)) {
			empty = false;
		} else if (Object.keys(obj).length > 0) {
			Object.keys(obj).forEach(function (key) {
				if (obj.hasOwnProperty(key) && key) {
					empty = false;
				}
			});
		}
		return empty;
	},
	camelize: function (value, split) {
		var result = "";
		if (split) {
			value = value.split(" ");
		} else {
			value = [value];
		}
		value.forEach(function (val, idx) {
			if (idx > 0) {
				result += " ";
			}
			result += val.charAt(0).toUpperCase() + val.substr(1).toLowerCase();
		});
		return result;
	},
	uniqueJsonFeatureValueCount: function (arr, key) {
		var obj = {}, val, count = 0;
		arr.forEach(function(item){
			val = item[key];
			if (obj[val]) {
				obj[val] += 1;
			} else {
				if (val) {
					obj[val] = 1;
					count += 1;
				}
			}
		});
		return count;
	},
	uniqueFeatureValueCount: function (arr, key) {
		var obj = {}, val, count = 0;
		$.each(arr, function () {
			console.log(this);
			val = this.get(key);
			if (obj[val]) {
				obj[val] += 1;
			} else {
				if (val) {
					obj[val] = 1;
					count += 1;
				}
			}
		});
		return count;
	},
	getDistanceBetweenFeatureAndPoint: globalFns.getDistanceBetweenFeatureAndPoint,
	sortByProximity: function (features, coords) {
		features.sort(function (a, b) {
			var aDist, bDist, order = -1;
			if (a.wktgeom) {
				var wkt = new WKT();
				a = wkt.readFeature(a.wktgeom);
				b = wkt.readFeature(b.wktgeom);
			}
			aDist = globalFns.getDistanceBetweenFeatureAndPoint(a, coords);
			bDist = globalFns.getDistanceBetweenFeatureAndPoint(b, coords);
			if (a.getGeometry().intersectsCoordinate(coords)) {
				aDist = 0;
			}
			if (b.getGeometry().intersectsCoordinate(coords)) {
				bDist = 0;
			}
			if (aDist > bDist) {
				order = 1;
			} else {
				order = -1;
			}
			return order;
		});
		return features;
	},
	/** Funksjoner for å lage HTML-elementer **/
	addLinkDiv: function (params) {
		var div, span;
		div = creator.createDiv({css: "link-div"});
		//div.className = "click-area link-div";
		span = creator.createSpan({css: "looklike-btn-link", text: params.innerHTML});
		if (params.external) {
			span.innerHTML += " <i class='icon-new-window'></i>";
		}
		if (params.title) {
			span.title = params.title;
		}
		div.appendChild(span);
		div.onclick = function (e) {
			window.open(params.target, params.opens ? params.opens : "_blank");
			e.stopPropagation();
		};

		return div;
	},
	clearSelectedFeatures: function () {
		this.map.getInteractionById("featureclick").getFeatures().clear();
	},
};
